module.exports = ":host{display:block;padding:8px;background:#263238;cursor:text;overflow:auto;-webkit-overflow-scrolling:touch}\n"